import { Button, Divider, Text, Modal } from '$components'
import { FilterIcon, ChevronLeftIcon } from '$components'
import { Filter } from './types'
import { Fragment, useState } from 'react'
import { useFilters } from './hooks/use-filters'
import { Options } from './options/options'

export type MobileFiltersProps = {
  filters: Filter[]
}

export function MobileFilters({ filters }: MobileFiltersProps) {
  const { isFiltersSet, clearFilters, getFilter } = useFilters()
  const [isMobileModalOpen, setMobileModalOpen] = useState(false)
  const [currentMobileView, setCurrentMobileView] = useState<'list' | 'filter'>('list')
  const [selectedMobileFilter, setSelectedMobileFilter] = useState<Filter | null>(null)

  const handleMobileFilterSelect = (filter: Filter) => {
    setSelectedMobileFilter(filter)
    setCurrentMobileView('filter')
  }

  const handleMobileBack = () => {
    setCurrentMobileView('list')
    setSelectedMobileFilter(null)
  }

  const handleMobileClose = () => {
    setMobileModalOpen(false)
    setCurrentMobileView('list')
    setSelectedMobileFilter(null)
  }

  return (
    <Fragment>
      <Button
        type="button"
        variant="secondary"
        icon={FilterIcon}
        onClick={() => setMobileModalOpen(true)}
        className="relative"
      >
        {isFiltersSet() && (
          <span className="size-2.5 rounded-pill bg-brand-hover absolute top-0 right-0" />
        )}
      </Button>

      {isMobileModalOpen && (
        <Modal onClose={handleMobileClose}>
          <Modal.Header>
            <div className="flex items-center gap-stack-tight">
              {currentMobileView === 'filter' && (
                <button
                  onClick={handleMobileBack}
                  className="p-stack-tight -ml-stack-tight border border-transparent hover:border-border rounded-surface transition-colors"
                >
                  <ChevronLeftIcon className="size-4 text-fg-muted" />
                </button>
              )}

              <Modal.Heading>
                {currentMobileView === 'list' ? 'Filters' : selectedMobileFilter?.label}
              </Modal.Heading>
            </div>
          </Modal.Header>

          <Modal.Content>
            {currentMobileView === 'list'
              ? (
                <Fragment>
                  {filters.map((filter, key) => {
                    const isActive = !!getFilter(filter)

                    return (
                      <button
                        key={key}
                        className="w-full p-stack-roomy focus:outline-none hover:bg-bg-subtle/50 flex items-center gap-stack cursor-pointer text-left rounded-card-sm md:hover:rounded-none"
                        onClick={() => handleMobileFilterSelect(filter)}
                      >
                        {filter.icon && (
                          <div className="flex-shrink-0">
                            <filter.icon className="size-5 text-fg-subtle" />
                          </div>
                        )}

                        <Text
                          type="s"
                          className="flex-1"
                        >
                          {filter.label}
                        </Text>

                        {isActive && (
                          <div className="size-2.5 rounded-pill bg-brand-hover" />
                        )}
                      </button>
                    )
                  })}

                  {isFiltersSet() && (
                    <Fragment>
                      <div className="m-stack-roomy">
                        <Divider />
                      </div>

                      <button
                        className="w-full p-stack-roomy focus:outline-none hover:bg-bg-subtle/50 cursor-pointer text-left rounded-card-sm md:hover:rounded-none"
                        onClick={() => {
                          clearFilters()
                          handleMobileClose()
                        }}
                      >
                        <Text type="s">
                          Clear filters
                        </Text>
                      </button>
                    </Fragment>
                  )}
                </Fragment>
              )
              : (
                selectedMobileFilter && (
                  <Options filters={[selectedMobileFilter]} />
                )
              )}
          </Modal.Content>
        </Modal>
      )}
    </Fragment>
  )
}
